// src/pages/Movies.jsx
import React, { useState, useEffect } from "react";
import MovieCard from "../components/MovieCard";
import GenreFilter from "../components/GenreFilter";
import "../styles/styles.css";
import { getAllMovies } from "../utils/movieUtils";
import { PageSEO } from "../hooks/useSEO";

const Movies = () => {
  const [allMovies, setAllMovies] = useState([]);
  const [filteredMovies, setFilteredMovies] = useState([]);
  const [selectedGenres, setSelectedGenres] = useState([]);

  useEffect(() => {
    const moviesList = getAllMovies();
    setAllMovies(moviesList);
    setFilteredMovies(moviesList);
  }, []);

  useEffect(() => {
    if (selectedGenres.length === 0) {
      setFilteredMovies(allMovies);
    } else {
      const filtered = allMovies.filter((movie) =>
        selectedGenres.every((g) => movie.genre.includes(g))
      );
      setFilteredMovies(filtered);
    }
  }, [selectedGenres, allMovies]);

  // Películas más populares para destacar (opcional)
  const popularMovies = [...allMovies].sort(
    (a, b) => b.popularity - a.popularity
  );

  // Obtener lista de todos los géneros en el catálogo de películas
  const allGenres = Array.from(
    new Set(allMovies.flatMap((movie) => movie.genre))
  );

  return (
    <div className="home-container">
      <PageSEO
        title="Películas IA"
        description="Explora películas originales creadas con inteligencia artificial. Ciencia ficción, drama, comedia y más — solo en AIVEO."
        url="/movies"
      />
      <div className="content-wrapper">
        {/* Título de la página */}
        <h2 style={{ color: "var(--color-text)", marginBottom: "1rem" }}>
          Catálogo de Películas
        </h2>

        {/* Filtro por género */}
        <GenreFilter
          genres={allGenres}
          selectedGenres={selectedGenres}
          setSelectedGenres={setSelectedGenres}
        />

        {/* Sección de películas destacadas (opcional) */}
        {popularMovies.length > 0 && (
          <section style={{ marginBottom: "2rem" }}>
            <h3
              style={{
                color: "var(--color-text)",
                fontSize: "1.5rem",
                marginBottom: "1rem",
              }}
            >
              Películas Destacadas
            </h3>
            <div className="series-grid">
              {popularMovies.slice(0, 4).map((movie) => (
                <MovieCard key={movie.id} movie={movie} />
              ))}
            </div>
          </section>
        )}

        {/* Grid de todas las películas filtradas */}
        <section>
          <h3
            style={{
              color: "var(--color-text)",
              fontSize: "1.5rem",
              marginBottom: "1rem",
            }}
          >
            Todas las Películas
          </h3>
          {filteredMovies.length > 0 ? (
            <div className="series-grid">
              {filteredMovies.map((movie) => (
                <MovieCard key={movie.id} movie={movie} />
              ))}
            </div>
          ) : (
            <p style={{ color: "var(--color-text-secondary)" }}>
              No se encontraron películas con los filtros seleccionados.
            </p>
          )}
        </section>
      </div>
    </div>
  );
};

export default Movies;